export const invokeRef = <T>(ref: React.ForwardedRef<T> | undefined, current: T | null) => {
  if (typeof ref === "function") {
    ref(current)
  } else if (ref != null) {
    ref.current = current
  }
}

export const extendRef =
  <T>(...refs: (React.ForwardedRef<T> | undefined)[]): React.ForwardedRef<T> =>
  (current: T | null) => {
    for (const ref of refs) {
      invokeRef(ref, current)
    }
  }
